<template>
  <el-input
    :model-value="value"
    :type="isShowPassword ? 'text' : 'password'"
    :autocomplete="disableAutofill ? 'one-time-code' : 'off'"
    :class="value ? 'has-value' : ''"
    show-password
    @input="(value) => $emit('input', value)"
    @blur="handleBlur"
  />
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    disableAutofill: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowPassword: false,
    };
  },
  methods: {
    handleBlur() {
      this.$emit('blur');
    },
  },
};
</script>
